// src/services/canalPagamento.js
// Decide POR ONDE a pessoa paga, conforme onde o app está rodando.
//
//   navegador / painéis do computador  → 'asaas'
//   app Android (Capacitor)            → 'google' (Google Play Billing) quando BILLING_GOOGLE_ATIVO = true
//
// ⚠️ PROVISÓRIO: enquanto BILLING_GOOGLE_ATIVO for false (a compra pelo Google ainda não existe), o app Android
// continua usando o Asaas, só para os testes internos. O Google Play NÃO aceita isso em produção para produto digital:
// **não publicar o app na loja antes de ligar o Billing** (ver docs/Billing_Google_Play_Desenho.md e CLAUDE.md).
import { Capacitor } from '@capacitor/core';

export const BILLING_GOOGLE_ATIVO = false;

export function canalDePagamento() {
  const noApp = Capacitor.isNativePlatform();
  if (noApp && BILLING_GOOGLE_ATIVO) return 'google';
  return 'asaas';
}

// Tela da Play Store onde a pessoa cancela/gerencia a assinatura comprada pelo Google Play.
export function linkGerenciarAssinaturaGoogle(productId) {
  const base = 'https://play.google.com/store/account/subscriptions';
  return productId
    ? base + '?sku=' + encodeURIComponent(productId) + '&package=br.com.vantumtecnologia.phoenixos'
    : base;
}
